"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var searchParamsSlice_1 = require("../../../../../../features/searchParams/searchParamsSlice");
var BlMultiDropdown_1 = __importDefault(require("../../../../../FormComponents/BlMultiDropdown"));
var BlDropdown_1 = __importDefault(require("../../../../../FormComponents/BlDropdown"));
var PostViewContentTypes_1 = require("../../../../../../constants/PostViewContentTypes");
var currencySlice_1 = require("../../../../../../features/currencies/currencySlice");
var FilterReducer_1 = require("../FilterReducer");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var SelectOptions = function (_a) {
    var handleUpdateFilters = _a.handleUpdateFilters, apartmentAvailabilities = _a.apartmentAvailabilities, propertyType = _a.propertyType;
    var t = react_i18next_1.useTranslation('common').t;
    var filters = react_redux_1.useSelector(searchParamsSlice_1.getFiltersGroup);
    var currency = react_redux_1.useSelector(currencySlice_1.selectCurrentCurrency);
    var _b = filters, rooms = _b.rooms, sqm_price = _b.sqm_price, area = _b.area, floor = _b.floor, availability = _b.availability;
    var _c = react_1.useReducer(FilterReducer_1.filterReducer, FilterReducer_1.initialState), filterValues = _c[0], dispatch = _c[1];
    react_1.useEffect(function () {
        handleUpdateFilters(filterValues);
    }, [filterValues]);
    react_1.useEffect(function () {
        dispatch({ type: 'resetSQMPrice' });
    }, [currency]);
    var onChangeFilter = function (name, value) {
        dispatch({
            type: 'update',
            payload: {
                name: name,
                value: value,
            },
        });
    };
    return (react_1.default.createElement("div", { className: "ui form" },
        react_1.default.createElement("div", { className: "ui two column centered grid" },
            react_1.default.createElement("div", { className: "two column row" },
                react_1.default.createElement("div", { className: "column" },
                    react_1.default.createElement("div", { className: "field" },
                        react_1.default.createElement(BlDropdown_1.default, { options: rooms.options.map(function (o) { return ({
                                value: o.val,
                                text: t("FIELD_OPTIONS." + o.text + "_rooms"),
                            }); }), placeholder: t('POST_PREVIEW.APT_HEADER_ROOMS'), fluid: true, multiple: true, selection: true, onChange: function (event, data) {
                                onChangeFilter('rooms', data.value);
                            } }))),
                react_1.default.createElement("div", { className: "column" },
                    react_1.default.createElement("div", { className: "field" },
                        react_1.default.createElement(BlDropdown_1.default, { options: sqm_price.options.map(function (o) { return ({
                                value: o.val,
                                text: o.text.split('- ').join('-\n'),
                            }); }), placeholder: t('POST_PREVIEW.APT_HEADER_SQM_PRICE'), fluid: true, multiple: true, selection: true, value: filterValues.sqm_price, onChange: function (event, data) {
                                onChangeFilter('sqm_price', data.value);
                            } })))),
            react_1.default.createElement("div", { className: "two column row" },
                react_1.default.createElement("div", { className: "column" },
                    react_1.default.createElement("div", { className: "field" },
                        react_1.default.createElement(BlDropdown_1.default, { options: area.options.map(function (o) { return ({
                                value: o.val,
                                text: t("FIELD_OPTIONS." + o.text),
                            }); }), placeholder: t('POST_PREVIEW.APT_HEADER_AREA'), fluid: true, multiple: true, selection: true, onChange: function (event, data) {
                                onChangeFilter('area', data.value);
                            } }))),
                react_1.default.createElement("div", { className: "column" },
                    react_1.default.createElement("div", { className: "field" },
                        react_1.default.createElement(BlDropdown_1.default, { options: floor.options.map(function (o) { return ({
                                value: o.val,
                                text: o.text,
                            }); }), placeholder: t('POST_PREVIEW.APT_HEADER_FLOOR'), fluid: true, multiple: true, selection: true, onChange: function (event, data) {
                                onChangeFilter('floor', data.value);
                            } })))),
            react_1.default.createElement("div", { className: "one column row" },
                react_1.default.createElement("div", { className: "column" },
                    react_1.default.createElement("div", { className: "field" },
                        react_1.default.createElement(BlMultiDropdown_1.default, { options: availability.options.map(function (o, index) { return ({
                                value: o.val,
                                text: t("FIELD_OPTIONS." + o.text),
                                count: apartmentAvailabilities[o.text] ||
                                    {},
                            }); }), placeholder: propertyType === PostViewContentTypes_1.SECTION_TYPES.HOUSE_INFO
                                ? t('POST_PREVIEW.BUILDING_VACANT_HOUSES_AMOUNT')
                                : propertyType ===
                                    PostViewContentTypes_1.SECTION_TYPES.APARTMENTS_INFO
                                    ? t('POST_PREVIEW.BUILDING_VACANT_APT_AMOUNT')
                                    : propertyType ===
                                        PostViewContentTypes_1.SECTION_TYPES.COMMERCIAL_INFO
                                        ? t('POST_PREVIEW.BUILDING_VACANT_COMMERCIALS_AMOUNT')
                                        : t('POST_PREVIEW.BUILDING_VACANT_APT_AMOUNT'), className: styles_module_scss_1.default.post_availability, value: filterValues.availability, onChange: function (data) {
                                onChangeFilter('availability', data);
                            } })))))));
};
exports.default = react_1.memo(SelectOptions);
